import type { TrackData, FeedbackData } from '../types';

export interface TrackRepository {
    track(dataTrack: TrackData): Promise<boolean>;
}

export const TrackRepository = Symbol('TrackRepository');

export interface FeedbackRepository {
    feedback<T>(data: FeedbackData<T>): Promise<boolean>;
}

export const FeedbackRepository = Symbol('FeedbackRepository');
